import React, { useState } from "react";
import "../styles/productCard.css";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../redux/actions/cartActions";
import Modal from "./../components/Modal";

const ProductCard = ({
  height,
  name,
  description,
  price,
  image,
  addToBag,
  isImageArray,
  navigateLink,
  rating,
  id,
  stock,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [isModalOpen, setIsModalOpen] = useState(false);
 
  const closeModal = () => {
      setIsModalOpen(false); // Close the modal
    };
  // Use displayedImage to determine which image to show based on hover state and isImageArray
  const handleNotification = () =>{
    setIsModalOpen(true);
  }
  const displayedImage =
    isImageArray && Array.isArray(image) && image.length > 1
      ? isHovered
        ? image[1]
        : image[0]
      : image || "https://via.placeholder.com/150";
      const handleAddToCart = () => {    
        const productDetails = {
          id: id,
          image: displayedImage, // Assuming the first image
          name: name,
          price: price,
          quantity: 1,
        };
    
        dispatch(addToCart(productDetails));
      };
  return (
    <>
    {image && image.length > 0 && (
      <Modal isOpen={isModalOpen} closeModal={closeModal} heading="Product Notification" data={{"id": id, "image": image[0]}} dataMode="productNotification"  />
    )}
    <div
      className="product-card flex flex-col relative"
      style={{ height: `${height}px` }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="product-image-container relative overflow-hidden"
        style={{ height: `${description ? height - 100 : height - 70}px` }}
      >
        <Link to={navigateLink}>
        {/* Use displayedImage to show the initial image, and only add the second image for hover if isImageArray is true */}
        <img
          src={displayedImage}
          alt={name}
          className={`w-full h-full object-cover transition duration-300 ${
            isImageArray ? "product-image" : ""
          } items-center`}
        />
        {isImageArray && image.length > 1 && (
          <img
            src={image[1]}
            alt={`${name}-hover`}
            className={`product-image-second w-full h-full object-cover absolute top-0 left-0 transition-opacity duration-500 transform ${
              isHovered ? "opacity-100 scale-105" : "opacity-0 scale-100"
            }`}
          />
        )}
        </Link>
      </div>
      <div
        className={`product-details grid items-center ${
          addToBag ? "grid-cols-12 md:gap-4 gap-1" : ""
        }`}
      >
        <div
          className={`text-left mt-2 ${
            addToBag ? (isMobile ? "col-span-10" : "col-span-8") : "col-span-12"
          }`}
        >
                  <Link to={navigateLink} className="hover:text-black">

          <p
            className={`productCardLabel overflow-hidden ${
              isMobile ? "text-sm" : ""
            }`}
          >
            
            {name} <span className="font-bold">({stock>0?(stock):"out of stock"})</span>
          </p>
          <p
            className={`productCardDescription overflow-hidden ${
              isMobile ? "text-xs" : ""
            }`}
          >
            {description}
          </p>
          <div className="flex items-center">

          {price && (
            <p className={`productCardPrice me-2 ${isMobile ? "text-sm" : ""}`}>
              Rs.{price}
            </p>
          )}
           {rating &&
           [1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`fa-star text-xs ${
            rating >= star ? 'fa-solid text-yellow-500' : 'fa-regular text-gray-400'
          }`}
          ></i>
        ))}
        </div>
          </Link>
        </div>
        {addToBag && stock && (
          <div
            className={`flex justify-end ${isMobile ? " col-span-2  pr-2" : "col-span-4"}`}
          >
            {isMobile ? (
              <img src="/assets/images/shopping-bag-icon.png" onClick={handleAddToCart} className="h-5 w-auto cursor-pointer"/>
                         ) : (
                          
              <button onClick={handleAddToCart}  className="add-to-bag-btn bg-black text-white px-2 py-2 font-semibold text-xs rounded-md transition duration-300 relative">
                <span className="button-text">ADD TO BAG</span>
                <i className="fas fa-shopping-bag hidden-icon"></i>
              </button>
            )}
          </div>
        )}
        {addToBag && !stock && (
          <div
            className={`flex justify-end ${isMobile ? " col-span-2  pr-2" : "col-span-4"}`}
          >
            {isMobile ? (
             <i className="fa-solid fa-bell cursor-pointer" onClick={handleNotification}></i>
            ) : 
            ( 
              <button onClick={handleNotification}  className="add-to-bag-btn bg-black text-white px-2 py-2 font-semibold text-xs rounded-md transition duration-300 relative">
                <span className="button-text">Notify</span>
                <i className="fa fa-bell hidden-icon"></i>
              </button>
            )}
          </div>
        )}
      </div>
      
    </div>
    </>
  );
};

export default ProductCard;
